import { TAGS, api } from "@/store/api.ts"
import { IActiveEffect } from "."

const basePath = "/effects"

export const effectsApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.EFFECTS]
})

export const effectsEndpoints = effectsApi.injectEndpoints({
  endpoints: (builder) => ({
    getActiveEffects: builder.query<IActiveEffect[], string>({
      query: (sessionId) => ({
        url: `${basePath}/active-effects/${sessionId}`,
        method: "GET"
      }),
      providesTags: () => [{ type: TAGS.EFFECTS, id: "ACTIVE-EFFECTS" }]
    })
  })
})

export const { useGetActiveEffectsQuery } = effectsEndpoints
